<template>
  <div class="home-container">
    <div class="after-login " v-if="isLogin">
      <div class="left">
        <p class="title">
          <b :class="{ active: activeTitle === 1 }" @click="activeTitle = 1">待审批</b>
          <b :class="{ active: activeTitle === 2 }" @click="activeTitle = 2">申请记录</b>
          <span @click="checkMore">查看更多 <i class="el-icon-arrow-right"></i></span>
        </p>
        <div class="divider"></div>
        <div class="table">
          <div class="table-header">
            <b>服务名称</b>
            <b>业务分类</b>
            <b v-if="activeTitle === 1">申请人</b>
            <b v-else>审批状态</b>
            <b>申请时间</b>
          </div>
          <template v-if="showList.length">
            <div class="table-row" v-for="item in showList">
              <span>{{ item.employName }}</span>
              <span>{{ item.categoryName }}</span>
              <span v-if="activeTitle === 1">{{ item.userName }}</span>
              <span class="status" v-else>
                <b
                  :style="{ '--color': ['var(--mainColor)', 'var(--successColor)', 'var(--dangerColor)', 'var(--infoColor)', 'var(--warningColor)', 'var(--auxColor)'][item.approvalStatus - 1] }">{{
                    ['审批中', '已通过', '未通过', '已撤销 ', '挂起 ', '已结束'][item.approvalStatus - 1] }}</b></span>
              <span>{{ item.createTime }}</span>
            </div>
          </template>
          <el-empty v-else></el-empty>
        </div>
      </div>

      <div class="right">
        <b>我的收藏</b>
        <div id="service" v-for="item in userData.userCollectEmployList" :key="item.employId"
          @click="$router.push(`guide?employId=${item.employId}`)">
          <p>
            <i :class="`iconfont icon-${item.icon}`"></i>
            <b>{{ item.employName }}</b>
            <el-tooltip placement="left" content="取消收藏">
              <i class="el-icon-star-on" @click.stop="collectService(item.employId)"></i>
            </el-tooltip>
          </p>
          <div>
            <span>{{ item.departmentName }}</span>
            <b :class="'type' + item.handleWay">{{ ['线下办理', '线上办理', '线上线下结合'][item.handleWay - 1] }}</b>
          </div>
        </div>
      </div>
    </div>

    <div class="home-inner">
      <div class="hot title" data-title="热门服务">
        <div id="service" v-for="item in serviceData.hotEmployList" :key="item.employId"
          @click="$router.push(`guide?employId=${item.employId}`)">
          <p>
            <i :class="`iconfont icon-${item.icon}`"></i>
            <b>{{ item.employName }}</b>
          </p>
          <div>
            <span>{{ item.departmentName }}</span>
            <b :class="'type' + item.handleWay">{{ ['线下办理', '线上办理', ' 线上线下结合'][item.handleWay - 1] }}</b>
          </div>
        </div>
      </div>

      <div class="combine">
        <div class="title" data-title="最新服务">
          <div id="service" v-for="item in serviceData.newEmployList" :key="item.employId"
            @click="$router.push(`guide?employId=${item.employId}`)">
            <p>
              <i :class="`iconfont icon-${item.icon}`"></i>
              <b>{{ item.employName }}</b>
            </p>
            <div>
              <span>{{ item.departmentName }}</span>
              <b :class="'type' + item.handleWay">{{ ['线下办理', '线上办理', ' 线上线下结合'][item.handleWay - 1] }}</b>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="title" data-title="推荐服务">
          <div id="service" v-for="item in serviceData.recommendEmployList" :key="item.employId"
            @click="$router.push(`guide?employId=${item.employId}`)">
            <p>
              <i :class="`iconfont icon-${item.icon}`"></i>
              <b>{{ item.employName }}</b>
            </p>
            <div>
              <span>{{ item.departmentName }}</span>
              <b :class="'type' + item.handleWay">{{ ['线下办理', '线上办理', ' 线上线下结合'][item.handleWay - 1] }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="修改密码" width="500px">
      <el-form :model="form" :rules="rules" label-width="95px" ref="form">
        <el-form-item label="原始密码" prop="password">
          <el-input size="medium" type="password" show-password v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input size="medium" type="password" show-password v-model="form.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input size="medium" type="password" show-password v-model="form.confirmPassword"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="medium" type="primary" @click="confirm">确定</el-button>
        <el-button size="medium" @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from './api'
import { collectService } from '../collection/api'
import { getConfigInfo } from '../login/api'
import { updatePassword } from '../personal/api'
export default {
  name: 'Home',
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value) {
        if (value === this.form.newPassword) {
          callback()
        } else {
          callback(new Error('两次输入的密码不一致'))
        }
      } else {
        callback(new Error('请输入确认密码'))
      }
      callback()
    }
    return {
      isLogin: JSON.parse(localStorage.getItem('isLogin')),
      baseUrl: localStorage.getItem('baseUrl'),
      userRole: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userDict : null,
      serviceData: {},
      userData: {
        todoApplyInfo: [],
        userApplyInfo: [],
      },
      activeTitle: 1,
      dialogVisible: false,
      form: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        password: [{ required: true, message: '请输入原始密码', trigger: 'change' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'change' }],
        confirmPassword: [{ required: true, validator: validateConfirmPassword, trigger: 'change' }]
      }
    }
  },
  computed: {
    showList() {
      return this.userData[this.activeTitle === 1 ? 'todoApplyInfo' : 'userApplyInfo']
    }
  },
  async created() {
    const { data } = await api.getServiceData({
      roles: this.userRole == 0 ? 2 : this.userRole == 2 ? 1 : this.userRole == 4 ? 3 : ''
    })
    this.serviceData = data
    if (this.isLogin) {
      this.getUserData()
      if (JSON.parse(localStorage.getItem('initPwd'))) {
        this.dialogVisible = true
        const { data: { settingValue, settingDescription } } = await getConfigInfo('psd_regex')
        const regex = new RegExp(settingValue)
        this.rules.newPassword.push({
          validator: (rule, value, callback) => {
            if (!value) return callback()
            if (regex.test(value)) callback()
            else callback(new Error(settingDescription))
          },
          trigger: 'change'
        })
      }
    }
  },
  methods: {
    async getUserData() {
      const { data } = await api.getUserData()
      this.userData = data
    },
    checkMore() {
      this.$router.push({ path: '/task', query: { checked: this.activeTitle === 1 ? 'todo' : 'apply' } })
    },
    async collectService(employId) {
      await collectService(employId)
      this.$message.success('已取消收藏')
      this.getUserData()
    },
    confirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          await updatePassword(this.form)
          this.$message.success('密码已修改')
          this.dialogVisible = false
          localStorage.removeItem('initPwd')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-container {
  min-height: calc(100vh - 340px);

  .after-login {
    height: 495px;
    width: var(--inner-width);
    // background: #fff;
    padding-top: 60px;
    margin: auto;
    display: flex;
    gap: 60px;

    .left {
      background: #fff;
      border-radius: 6px;
      flex: 1;
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 15px;

      .title {
        display: flex;
        align-items: flex-start;
        gap: 50px;
        font-family: serif;

        b {
          color: #333;
          font-size: 24px;
          font-weight: bold;
          transition: 300ms;
          cursor: pointer;

          &.active {
            color: $mainColor;
          }
        }

        span {
          margin-left: auto;
          color: $mainColor;
          font-weight: 500;
          cursor: pointer;
        }
      }

      .divider {
        background: $mainColor;
        min-height: 2px;
        opacity: .5;
      }

      .table {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 32px;

        &-header {
          display: flex;

          b {
            flex: 1;
            color: #999;
            font-size: 17px;
            text-align: center;

            &:first-child {
              text-align: left;
            }

            &:last-child {
              text-align: right;
            }
          }
        }

        &-row {
          display: flex;

          span {
            flex: 1;
            color: #666;
            text-align: center;

            &:first-child {
              text-align: left;

              &::before {
                content: '';
                display: inline-block;
                width: 6px;
                aspect-ratio: 1;
                background: $mainColor;
                border-radius: 50%;
                margin-right: 10px;
                transform: translateY(-2px);
              }
            }

            &:last-child {
              text-align: right;
            }

            &.status b {
              display: inline-block;
              width: 50px;
              font-size: 12px;
              padding: 2px;
              border-radius: 2px;
              color: var(--color);
              border: 1px solid var(--color);
            }
          }
        }
      }
    }

    .right {
      background: #fff;
      border-radius: 6px;
      width: 400px;
      padding: 20px;
      display: grid;
      grid-template-rows: 28px repeat(3, 1fr);
      gap: 25px;

      >b {
        font-size: 24px;
        color: #333;
        font-family: serif;
      }
    }
  }

  .home-inner {
    width: var(--inner-width);
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 120px;
    padding: 120px 0 60px;

    .title {
      display: grid;
      position: relative;

      &::before {
        content: '';
        width: 4px;
        height: 22px;
        left: 2px;
        background: var(--mainColor);
        position: absolute;
        top: -48px;
        color: #333;
      }

      &::after {
        content: attr(data-title);
        position: absolute;
        top: -52px;
        left: 15px;
        color: #333;
        font-size: 24px;
        font-weight: bold;
        font-family: serif;
      }
    }

    .hot {
      position: relative;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px 27px;
    }

    .combine {
      display: flex;
      justify-content: space-between;
      align-items: stretch;

      .divider {
        width: 2px;
        background: #f2f2f2;
        margin: 0 20px;
      }

      .title {
        flex: 1;
        height: fit-content;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
      }
    }
  }

  ::v-deep .el-dialog__body {
    display: flex;
    justify-content: center;

    .el-input {
      width: 300px;
    }
  }
}
</style>